<template>
  <div id="aged-detail" class="page">
    <el-row>
      <el-col :span="24">
        <el-button size="small" type="primary" icon="el-icon-arrow-left" @click="skip()" plain>返回</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-card class="box-card" style="margin-top: 20px">
              <el-tabs value="1">
                <el-tab-pane label="长者动态" name="1">
                  <div class="tab-pane" :style="{'height':($store.state.minPageHeight - 300) +'px'}">
                    <el-scrollbar style="height: 100%">
                      <div class="block" style="padding: 15px">
                        <el-timeline :reverse="false">
                          <el-timeline-item
                              v-for="(log, index) in agedLogs"
                              :key="index"
                              :timestamp="log.logTime">
                            {{log.content}}
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </el-scrollbar>
                  </div>
                </el-tab-pane>
<!--                <el-tab-pane label="长者资料" name="2">-->
<!--                  <div class="tab-pane">-->
<!--                    <div style="display: flex">-->
<!--                      <div style="width: 120px">-->
<!--                        <el-steps direction="vertical" :space="0" finish-status="success">-->
<!--                          <el-step title="基本信息" status="process" style="min-height: 800px"></el-step>-->
<!--                          <el-step title="家属信息" status="process" v-if="agedInfo.relatives && agedInfo.relatives.length > 0"-->
<!--                                   :style="{'min-height': (220 * (agedInfo.relatives.length) + 80)+'px'}"></el-step>-->
<!--                          <el-step title="其他信息" status="process" style="min-height: 450px"></el-step>-->
<!--                        </el-steps>-->
<!--                      </div>-->
<!--                      <div style="width: 100%;padding: 20px">-->
<!--                        <el-row style="padding-top: 30px">-->
<!--                          <el-col :span="24">-->
<!--                            <el-form ref="aged-info-form" :model="agedInfo" label-width="120px" size="small" disabled>-->
<!--                              <div>-->
<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="24">-->
<!--                                    <el-form-item label="照片">-->
<!--                                      <el-image v-if="agedInfo.icon"-->
<!--                                                style="width: 200px; height: 200px"-->
<!--                                                :src="'file/image/'+agedInfo.icon"-->
<!--                                                :preview-src-list="['file/image/'+agedInfo.icon]"-->
<!--                                                fit="cover"></el-image>-->
<!--                                      <el-image v-else-->
<!--                                                style="width: 200px; height: 200px"-->
<!--                                                src="/asert/image/default-head.png"-->
<!--                                                fit="cover"></el-image>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="所属住宅">-->
<!--                                      <el-select v-model="agedInfo.familyId" filterable placeholder="请选择所属住宅">-->
<!--                                        <el-option-->
<!--                                            v-for="item in families"-->
<!--                                            :key="item.id"-->
<!--                                            :label="item.name"-->
<!--                                            :value="item.id">-->
<!--                                        </el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="孝心环">-->
<!--                                      <el-input v-model="agedInfo.xiaoxinhuan"-->
<!--                                                placeholder="请输入孝心环"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="证件号" prop="idCard">-->
<!--                                      <el-input v-model="agedInfo.idCard"-->
<!--                                                placeholder="请输入证件号" disabled></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="证件类型">-->
<!--                                      <el-select v-model="agedInfo.cardType" placeholder="请选择证件类型">-->
<!--                                        <el-option label="身份证" value="ID_CARD"></el-option>-->
<!--                                        <el-option label="驾驶证" value="DRIVER_LICENSE"></el-option>-->
<!--                                        <el-option label="护照" value="PASS_PORT"></el-option>-->
<!--                                        <el-option label="临时" value="TEMPORARY"></el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="姓名" prop="agedName">-->
<!--                                      <el-input v-model="agedInfo.agedName"-->
<!--                                                placeholder="请输入姓名"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="性别">-->
<!--                                      <el-radio v-model="agedInfo.agedSex" :label="1">男</el-radio>-->
<!--                                      <el-radio v-model="agedInfo.agedSex" :label="2">女</el-radio>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--&lt;!&ndash;                                <el-row :gutter="20">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <el-col :span="12">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <el-form-item label="生日">&ndash;&gt;-->
<!--&lt;!&ndash;                                      <el-row>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <el-col :span="24">&ndash;&gt;-->
<!--&lt;!&ndash;                                          <el-date-picker&ndash;&gt;-->
<!--&lt;!&ndash;                                              v-model="agedInfo.birthday"&ndash;&gt;-->
<!--&lt;!&ndash;                                              align="right"&ndash;&gt;-->
<!--&lt;!&ndash;                                              type="date"&ndash;&gt;-->
<!--&lt;!&ndash;                                              placeholder="选择日期"&ndash;&gt;-->
<!--&lt;!&ndash;                                              value-format="yyyy-MM-dd"&ndash;&gt;-->
<!--&lt;!&ndash;                                              :picker-options="birthPickerOptions">&ndash;&gt;-->
<!--&lt;!&ndash;                                          </el-date-picker>&ndash;&gt;-->
<!--&lt;!&ndash;                                        </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;                                      </el-row>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </el-form-item>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;                                  <el-col :span="12">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <el-form-item label="联系电话" prop="phone">&ndash;&gt;-->
<!--&lt;!&ndash;                                      <el-input v-model="agedInfo.phone"&ndash;&gt;-->
<!--&lt;!&ndash;                                                placeholder="请输入联系电话"></el-input>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </el-form-item>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;                                </el-row>&ndash;&gt;-->

<!--&lt;!&ndash;                                <el-row :gutter="20">&ndash;&gt;-->
<!--&lt;!&ndash;                                  <el-col :span="12">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <el-form-item label="本市户籍">&ndash;&gt;-->
<!--&lt;!&ndash;                                      <el-select v-model="agedInfo.isLocal"&ndash;&gt;-->
<!--&lt;!&ndash;                                                 placeholder="请选择是否本地户籍">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <el-option label="是" :value="true"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                                        <el-option label="否" :value="false"></el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                                      </el-select>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </el-form-item>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;                                  <el-col :span="12">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <el-form-item label="补贴标准">&ndash;&gt;-->
<!--&lt;!&ndash;                                      <el-select v-model="agedInfo.subsidyStandard" filterable&ndash;&gt;-->
<!--&lt;!&ndash;                                                 placeholder="请选择补贴标准">&ndash;&gt;-->
<!--&lt;!&ndash;                                        <el-option&ndash;&gt;-->
<!--&lt;!&ndash;                                            v-for="item in agedStandards"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :key="item.id"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :label="item.name"&ndash;&gt;-->
<!--&lt;!&ndash;                                            :value="item.id">&ndash;&gt;-->
<!--&lt;!&ndash;                                        </el-option>&ndash;&gt;-->
<!--&lt;!&ndash;                                      </el-select>&ndash;&gt;-->
<!--&lt;!&ndash;                                    </el-form-item>&ndash;&gt;-->
<!--&lt;!&ndash;                                  </el-col>&ndash;&gt;-->
<!--&lt;!&ndash;                                </el-row>&ndash;&gt;-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="人员来源">-->
<!--                                      <el-row>-->
<!--                                        <el-col :span="24">-->
<!--                                          <el-select v-model="agedInfo.agedSource"-->
<!--                                                     placeholder="请选择人员来源">-->
<!--                                            <el-option label="社会化老人" value="SOCIETY"></el-option>-->
<!--                                            <el-option label="政府购买" value="GOVERNMENT"></el-option>-->
<!--                                          </el-select>-->
<!--                                        </el-col>-->
<!--                                      </el-row>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="电话回访">-->
<!--                                      <el-radio v-model="agedInfo.callbackSupport" :label="true">支持-->
<!--                                      </el-radio>-->
<!--                                      <el-radio v-model="agedInfo.callbackSupport" :label="false">-->
<!--                                        不支持-->
<!--                                      </el-radio>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="类别">-->
<!--                                      <el-row>-->
<!--                                        <el-col :span="24">-->
<!--                                          <el-select v-model="agedInfo.agedType" filterable-->
<!--                                                     placeholder="请选择长者类型">-->
<!--                                            <el-option-->
<!--                                                v-for="item in agedTypes"-->
<!--                                                :key="item.id"-->
<!--                                                :label="item.name"-->
<!--                                                :value="item.id">-->
<!--                                            </el-option>-->
<!--                                          </el-select>-->
<!--                                        </el-col>-->
<!--                                      </el-row>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="服务状态">-->
<!--                                      <el-select v-model="agedInfo.serviceStatus"-->
<!--                                                 placeholder="请选择服务状态">-->
<!--                                        <el-option label="未审核" value="NOT_APPROVED"></el-option>-->
<!--                                        <el-option label="未派单" value="UNDELIVERED"></el-option>-->
<!--                                        <el-option label="未安装" value="NOT_INSTALLED"></el-option>-->
<!--                                        <el-option label="未激活" value="NOT_ACTIVE"></el-option>-->
<!--                                        <el-option label="正常服务" value="NORMAL"></el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="24">-->
<!--                                    <el-form-item label="服务地址" prop="location">-->
<!--                                      <el-input-->
<!--                                          placeholder="请输入服务地址"-->
<!--                                          v-model="agedInfo.location">-->
<!--                                      </el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="24">-->
<!--                                    <el-form-item label="注意事项">-->
<!--                                      <el-input-->
<!--                                          type="textarea"-->
<!--                                          :rows="6"-->
<!--                                          placeholder="请输入服务注意事项"-->
<!--                                          v-model="agedInfo.notices">-->
<!--                                      </el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                              </div>-->
<!--                              <div style="margin-top: 60px">-->
<!--                                <el-row :gutter="20" type="flex" align="middle">-->
<!--                                  <el-col v-if="agedInfo.relatives.length > 0" :span="24">-->
<!--                                    <div v-for="(member, index) in agedInfo.relatives"-->
<!--                                         class="family-member-row">-->
<!--                                      <el-row type="flex" justify="center">-->
<!--                                        <el-col :span="11">-->
<!--                                          <el-row>-->
<!--                                            <el-col :span="19">-->
<!--                                              <el-form-item label="姓名"-->
<!--                                                            :rules="{required: true, message: '请输入亲属姓名',trigger:'blur'}"-->
<!--                                                            :prop="'relatives['+index+'].name'">-->
<!--                                                <el-input v-model="member.name"-->
<!--                                                          placeholder="请输入亲属姓名"></el-input>-->
<!--                                              </el-form-item>-->
<!--                                            </el-col>-->
<!--                                            <el-col :span="5">-->
<!--                                              <el-form-item label-width="0px"-->
<!--                                                            :rules="{required: true, message: '请选择亲属关系',trigger:'blur'}"-->
<!--                                                            :prop="'relatives['+index+'].relationship'">-->
<!--                                                <el-select v-model="member.relationship"-->
<!--                                                           placeholder="请选择亲属关系" clearable>-->
<!--                                                  <el-option label="父母"-->
<!--                                                             value="PARENTS"></el-option>-->
<!--                                                  <el-option label="子女"-->
<!--                                                             value="CHILDREN"></el-option>-->
<!--                                                  <el-option label="配偶"-->
<!--                                                             value="COUPLE"></el-option>-->
<!--                                                  <el-option label="其他亲属"-->
<!--                                                             value="RELATIVE"></el-option>-->
<!--                                                  <el-option label="护工"-->
<!--                                                             value="WORKER"></el-option>-->
<!--                                                  <el-option label="其他"-->
<!--                                                             value="OTHER"></el-option>-->
<!--                                                </el-select>-->
<!--                                              </el-form-item>-->
<!--                                            </el-col>-->
<!--                                          </el-row>-->
<!--                                        </el-col>-->
<!--                                        <el-col :span="11" :offset="1">-->
<!--                                          <el-form-item label="监护人"-->
<!--                                                        :rules="{required: true, message: '请选择是否是监护人',trigger:'blur'}"-->
<!--                                                        :prop="'relatives['+index+'].isGuardian'">-->
<!--                                            <el-select v-model="member.isGuardian"-->
<!--                                                       placeholder="请选择是否是监护人">-->
<!--                                              <el-option label="是" :value="true"></el-option>-->
<!--                                              <el-option label="否" :value="false"></el-option>-->
<!--                                            </el-select>-->
<!--                                          </el-form-item>-->
<!--                                        </el-col>-->
<!--                                      </el-row>-->
<!--                                      <el-row type="flex" justify="center">-->
<!--                                        <el-col :span="11">-->
<!--                                          <el-form-item label="身份证号"-->
<!--                                                        :rules="{required: true, message: '请输入亲属身份证号',trigger:'blur'}"-->
<!--                                                        :prop="'relatives['+index+'].idCard'">-->
<!--                                            <el-input v-model="member.idCard"-->
<!--                                                      placeholder="请输入亲属身份证号"></el-input>-->
<!--                                          </el-form-item>-->
<!--                                        </el-col>-->
<!--                                        <el-col :span="11" :offset="1">-->
<!--                                          <el-form-item label="联系方式"-->
<!--                                                        :rules="{required: true, message: '请输入亲属电话',trigger:'blur'}"-->
<!--                                                        :prop="'relatives['+index+'].phone'">-->
<!--                                            <el-input v-model="member.phone"-->
<!--                                                      placeholder="请输入亲属电话"></el-input>-->
<!--                                          </el-form-item>-->
<!--                                        </el-col>-->
<!--                                      </el-row>-->
<!--                                      <el-row type="flex" justify="center">-->
<!--                                        <el-col :span="23">-->
<!--                                          <el-form-item label="地址">-->
<!--                                            <el-input v-model="member.location"-->
<!--                                                      placeholder="请输入地址"></el-input>-->
<!--                                          </el-form-item>-->
<!--                                        </el-col>-->
<!--                                      </el-row>-->
<!--                                    </div>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                              </div>-->
<!--                              <div style="margin-top: 90px">-->
<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="称呼">-->
<!--                                      <el-input v-model="agedInfo.nickName"-->
<!--                                                placeholder="请输入称呼"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="婚姻状况">-->
<!--                                      <el-select v-model="agedInfo.marriageStatus"-->
<!--                                                 placeholder="请选择婚姻状况"-->
<!--                                                 clearable>-->
<!--                                        <el-option label="已婚" value="MARRIED"></el-option>-->
<!--                                        <el-option label="未婚" value="UNMARRIED"></el-option>-->
<!--                                        <el-option label="丧偶" value="WIDOWED"></el-option>-->
<!--                                        <el-option label="离异" value="DIVORCE"></el-option>-->
<!--                                        <el-option label="其他" value="OTHER"></el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="政治面貌">-->
<!--                                      <el-input v-model="agedInfo.politicalOutlook"-->
<!--                                                placeholder="请输入政治面貌"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="血型">-->
<!--                                      <el-input v-model="agedInfo.bloodType"-->
<!--                                                placeholder="请输入血型"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="民族">-->
<!--                                      <el-input v-model="agedInfo.nation"-->
<!--                                                placeholder="请输入民族"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="宗教信仰">-->
<!--                                      <el-input v-model="agedInfo.religious"-->
<!--                                                placeholder="请输入宗教信仰"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="文化程度">-->
<!--                                      <el-input v-model="agedInfo.education"-->
<!--                                                placeholder="请输入文化程度"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="住宅人口">-->
<!--                                      <el-input-number v-model="agedInfo.population" :min="1"-->
<!--                                                       label="住宅人口"></el-input-number>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="休养类型">-->
<!--                                      <el-select v-model="agedInfo.holdType" placeholder="请选择休养类型"-->
<!--                                                 clearable>-->
<!--                                        <el-option label="社会代养" value="社会代养"></el-option>-->
<!--                                        <el-option label="政府供养" value="政府供养"></el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="供养标准">-->
<!--                                      <el-input v-model="agedInfo.offerStandard"-->
<!--                                                placeholder="请输入供养标准"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="供养方式">-->
<!--                                      <el-select v-model="agedInfo.offerType" placeholder="请选择供养方式"-->
<!--                                                 clearable>-->
<!--                                        <el-option label="居家" value="HOME"></el-option>-->
<!--                                        <el-option label="机构" value="INSTITUTION"></el-option>-->
<!--                                        <el-option label="其他" value="OTHER"></el-option>-->
<!--                                      </el-select>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                  <el-col :span="12">-->
<!--                                    <el-form-item label="爱好">-->
<!--                                      <el-input v-model="agedInfo.hobby"-->
<!--                                                placeholder="请输入爱好"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->

<!--                                <el-row :gutter="20">-->
<!--                                  <el-col :span="24">-->
<!--                                    <el-form-item label="户籍地址">-->
<!--                                      <el-input v-model="agedInfo.permanentAddress"-->
<!--                                                placeholder="请输入户籍地址"></el-input>-->
<!--                                    </el-form-item>-->
<!--                                  </el-col>-->
<!--                                </el-row>-->
<!--                              </div>-->
<!--                            </el-form>-->
<!--                          </el-col>-->
<!--                        </el-row>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </el-tab-pane>-->
                <el-tab-pane label="健康档案" name="3">
                  <div class="tab-pane">
                    <div>
                      <div class="page-title">
                        <span class="card-label card-title">&nbsp;&nbsp;体检信息&nbsp;&nbsp;</span>
                      </div>
                      <div>
                        <el-table :data="registrationTable.data" stripe highlight-current-row>
                          <el-table-column prop="agedName" label="姓名"></el-table-column>
                          <el-table-column prop="checkDate" label="体检时间" width="180"></el-table-column>
                          <el-table-column prop="checkLocation" label="体检地点"></el-table-column>
                          <el-table-column prop="result" label="体检结果"></el-table-column>
                          <el-table-column prop="registrationPerson" label="登记人"></el-table-column>
                          <el-table-column prop="registrationTime" label="登记时间" width="180"></el-table-column>
                        </el-table>
                      </div>
                      <div class="pagination">
                        <el-pagination
                            @current-change="loadHealthCheckTable"
                            @size-change="loadHealthCheckTable"
                            :current-page.sync="registrationTable.page.currentPage"
                            :page-sizes="[10, 50, 100]"
                            :page-size.sync="registrationTable.page.pageSize"
                            layout="sizes,  prev, pager, next, total"
                            :total="registrationTable.page.total">
                        </el-pagination>
                      </div>
                    </div>
                    <div>
                      <div class="page-title">
                        <span class="card-label card-title">&nbsp;&nbsp;健康信息&nbsp;&nbsp;</span>
                      </div>
                      <el-table :data="healthTable.data" stripe highlight-current-row>
                        <el-table-column prop="agedName" label="姓名"></el-table-column>
                        <el-table-column prop="fastingBloodGlucose" label="血糖(mmol/L)" width="120"></el-table-column>
                        <el-table-column prop="lowPressure" label="舒张压(mmHg)" width="120"></el-table-column>
                        <el-table-column prop="highPressure" label="收缩压(mmHg)" width="120"></el-table-column>
                        <el-table-column prop="bloodOxygen" label="血氧(%)"></el-table-column>
                        <el-table-column prop="heartRate" label="心率(次/分)"></el-table-column>
                        <el-table-column prop="totalCholesterol" label="胆固醇(mmol/L)" width="140"></el-table-column>
                        <el-table-column prop="doctorAnnotation" label="医生批注"></el-table-column>
                        <el-table-column fixed="right" label="操作">
                          <template slot-scope="scope">
                            <el-button @click.native.prevent="loadHealthInfo(scope.row.id)" type="text" size="small">
                              详情
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="pagination">
                        <el-pagination
                            @current-change="loadHealthTable"
                            @size-change="loadHealthTable"
                            :current-page.sync="healthTable.page.currentPage"
                            :page-sizes="[10, 50, 100]"
                            :page-size.sync="healthTable.page.pageSize"
                            layout="sizes,  prev, pager, next, total"
                            :total="healthTable.page.total">
                        </el-pagination>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="附件管理" name="4">
                  <div class="tab-pane">
                    <el-form ref="aged-file-form" :model="agedInfo" label-width="120px" size="small">
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="身份证">
                            <template v-for="file in files.idCardFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.idCardFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="idCardUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="入住协议">
                            <template v-for="file in files.moveInFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.moveInFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="moveInUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="户口本">
                            <template v-for="file in files.familyRegisterFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.familyRegisterFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="familyRegisterUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="收据">
                            <template v-for="file in files.receiptFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.receiptFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="receiptUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="报告">
                            <template v-for="file in files.reportFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.reportFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="reportUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="合同">
                            <template v-for="file in files.contractFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.contractFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="contractUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="其他">
                            <template v-for="file in files.otherFile">
                              <div class="img-line">
                                <el-image v-if="file.fileId"
                                          style="width: 150px; height: 150px"
                                          :src="ip+file.filePath"
                                          :preview-src-list="allFile(files.otherFile)"
                                          fit="cover">
                                </el-image>
                                <i class="el-icon-delete img-line-button" @click="removeFile(file.fileId)"></i>
                              </div>
                            </template>
                            <el-upload
                                class="avatar-uploader el-image"
                                action="/system-ya/file/upload/picture"
                                :show-file-list="false"
                                :on-success="otherUpload">
                              <i style="width: 150px; height: 150px; line-height: 150px" class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-form>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工单管理" name="5">
                  <div class="tab-pane">
                    <div>
                      <el-table :data="woTable.data" stripe highlight-current-row>
                        <el-table-column prop="woCode" label="工单号" width="160" fixed></el-table-column>
                        <el-table-column prop="servicePerson" label="服务人员" width="180"></el-table-column>
                        <el-table-column :formatter="enumsFormatter" prop="serviceType" label="服务类型"  width="180"></el-table-column>
                        <el-table-column prop="planStartTime" label="计划开始时间"  width="180"></el-table-column>
                        <el-table-column prop="actStartTime" label="实际开始时间" width="180"></el-table-column>
                        <el-table-column prop="actEndTime" label="实际完成时间" width="180"></el-table-column>
                        <el-table-column prop="workOrderContent" label="服务内容" show-overflow-tooltip width="180"></el-table-column>
                        <el-table-column :formatter="enumsFormatter" prop="woStatus" label="工单状态" width="180"></el-table-column>
                        <el-table-column fixed="right" label="操作"  width="160">
                          <template slot-scope="scope">
                            <el-button type="text" size="small" @click="showActivity(scope.row.id)">记录</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="pagination">
                      <el-pagination
                          @current-change="loadWoTable"
                          @size-change="loadWoTable"
                          :current-page.sync="woTable.page.currentPage"
                          :page-sizes="[10, 50, 100]"
                          :page-size.sync="woTable.page.pageSize"
                          layout="sizes,  prev, pager, next, total"
                          :total="woTable.page.total">
                      </el-pagination>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--二维码弹框-->
    <el-dialog :visible.sync="qrCodeDialog.visible" width="440px">
      <div id="aged-qr-code"></div>
    </el-dialog>

    <!--完善信息弹框-->
    <el-dialog
        v-if="agedDialog.visible"
        :title="agedDialog.title"
        :visible.sync="agedDialog.visible"
        :close-on-click-modal="false" top="7vh"
        width="90%">
      <div class="dialog-page" :style="{'height':(indexVue.minPageHeight - 300) +'px'}">
        <el-scrollbar style="height: 100%">
          <div style="display: flex">
            <div style="width: 120px">
              <el-steps direction="vertical" :space="0" finish-status="success">
                <el-step title="基本信息" status="process" style="min-height: 940px"></el-step>
                <el-step title="家属信息" status="process"
                         :style="{'min-height': (220 * (agedDialog.form.relatives.length>0?agedDialog.form.relatives.length:1) + 80)+'px'}"></el-step>
                <el-step title="其他信息" status="process" style="min-height: 450px"></el-step>
                <el-step title="提交" status="success"></el-step>
              </el-steps>
            </div>
            <div style="width: 100%;padding: 20px">
              <el-row style="padding-top: 30px">
                <el-col :span="24">
                  <el-form ref="aged-form" :model="agedDialog.form" :rules="agedDialog.rules"
                           label-width="120px"
                           size="small">
                    <div>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="照片">
                            <el-upload
                                class="avatar-uploader"
                                action="file/upload/picture"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess">
                              <img v-if="agedDialog.form.icon"
                                   :src="'file/image/'+agedDialog.form.icon" class="avatar">
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="所属住宅">
                            <el-select v-model="agedDialog.form.familyId" filterable placeholder="请选择所属住宅">
                              <el-option
                                  v-for="item in families"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="证件号" prop="idCard">
                            <el-input v-model="agedDialog.form.idCard"
                                      placeholder="请输入证件号"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="证件类型">
                            <el-select v-model="agedDialog.form.cardType" placeholder="请选择证件类型">
                              <el-option label="身份证" value="ID_CARD"></el-option>
                              <el-option label="驾驶证" value="DRIVER_LICENSE"></el-option>
                              <el-option label="护照" value="PASS_PORT"></el-option>
                              <el-option label="临时" value="TEMPORARY"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="姓名" prop="agedName">
                            <el-input v-model="agedDialog.form.agedName"
                                      placeholder="请输入姓名"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="性别">
                            <el-radio v-model="agedDialog.form.agedSex" :label="1">男</el-radio>
                            <el-radio v-model="agedDialog.form.agedSex" :label="2">女</el-radio>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="生日">
                            <el-row>
                              <el-col :span="24">
                                <el-date-picker
                                    v-model="agedDialog.form.birthday"
                                    align="right"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="birthPickerOptions">
                                </el-date-picker>
                              </el-col>
                              <!--<el-col :span="4">
                                  <el-select v-model="agedDialog.form.birthDateType" placeholder="请选择证件类型">
                                      <el-option label="阳历" value="1"></el-option>
                                      <el-option label="阴历" value="2"></el-option>
                                  </el-select>
                              </el-col>-->
                            </el-row>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="联系电话" prop="phone">
                            <el-input v-model="agedDialog.form.phone"
                                      placeholder="请输入联系电话"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="本市户籍">
                            <el-select v-model="agedDialog.form.isLocal"
                                       placeholder="请选择是否本地户籍">
                              <el-option label="是" :value="true"></el-option>
                              <el-option label="否" :value="false"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="补贴标准">
                            <el-select v-model="agedDialog.form.subsidyStandard" filterable
                                       placeholder="请选择补贴标准">
                              <el-option
                                  v-for="item in agedStandards"
                                  :key="item.id"
                                  :label="item.name"
                                  :value="item.id">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="人员来源">
                            <el-row>
                              <el-col :span="24">
                                <el-select v-model="agedDialog.form.agedSource"
                                           placeholder="请选择人员来源">
                                  <el-option label="社会化老人" value="SOCIETY"></el-option>
                                  <el-option label="政府购买" value="GOVERNMENT"></el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="电话回访">
                            <el-radio v-model="agedDialog.form.callbackSupport" :label="true">支持
                            </el-radio>
                            <el-radio v-model="agedDialog.form.callbackSupport" :label="false">
                              不支持
                            </el-radio>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="类别">
                            <el-row>
                              <el-col :span="24">
                                <el-select v-model="agedDialog.form.agedType" filterable
                                           placeholder="请选择长者类型">
                                  <el-option
                                      v-for="item in agedTypes"
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="服务状态">
                            <el-select v-model="agedDialog.form.serviceStatus"
                                       placeholder="请选择服务状态">
                              <el-option label="未审核" value="NOT_APPROVED"></el-option>
                              <el-option label="未派单" value="UNDELIVERED"></el-option>
                              <el-option label="未安装" value="NOT_INSTALLED"></el-option>
                              <el-option label="未激活" value="NOT_ACTIVE"></el-option>
                              <el-option label="正常服务" value="NORMAL"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="1">
                        <el-col :span="8">
                          <el-form-item label="服务地址" prop="" >
                            <el-select v-model="agedDialog.form.province" placeholder="省" @change="getCitys" clearable>
                              <el-option
                                  v-for="item in provinces"
                                  :key="item.id"
                                  :label="item.regionName"
                                  :value="item.regionCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item  prop="" label-width="0px">
                            <el-select v-model="agedDialog.form.city" placeholder="市" @change="getCountys" clearable>
                              <el-option
                                  v-for="item in citys"
                                  :key="item.id"
                                  :label="item.regionName"
                                  :value="item.regionCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item  prop="" label-width="0px">
                            <el-select v-model="agedDialog.form.county" placeholder="县" @change="getAreas" clearable>
                              <el-option
                                  v-for="item in countys"
                                  :key="item.id"
                                  :label="item.regionName"
                                  :value="item.regionCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item  prop="" >
                            <el-select v-model="agedDialog.form.area" placeholder="区" @change="getStreets" clearable>
                              <el-option
                                  v-for="item in areas"
                                  :key="item.id"
                                  :label="item.regionName"
                                  :value="item.regionCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item  prop="" label-width="0px">
                            <el-select v-model="agedDialog.form.street" placeholder="街道" clearable>
                              <el-option
                                  v-for="item in streets"
                                  :key="item.id"
                                  :label="item.regionName"
                                  :value="item.regionCode">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="" prop="location">
                            <el-input
                                placeholder="请输入服务地址"
                                v-model="agedDialog.form.location" readonly>
                              <el-button slot="append" icon="el-icon-search" @click="openMapDialog">地图</el-button>
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="注意事项">
                            <el-input
                                type="textarea"
                                :rows="6"
                                placeholder="请输入服务注意事项"
                                v-model="agedDialog.form.notices">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="margin-top: 60px">
                      <el-row :gutter="20" type="flex" align="middle">
                        <el-col v-if="agedDialog.form.relatives.length > 0" :span="24">
                          <div v-for="(member, index) in agedDialog.form.relatives"
                               class="family-member-row">
                            <el-row type="flex" justify="center">
                              <el-col :span="11">
                                <el-row>
                                  <el-col :span="19">
                                    <el-form-item label="姓名"
                                                  :rules="{required: true, message: '请输入亲属姓名',trigger:'blur'}"
                                                  :prop="'relatives['+index+'].name'">
                                      <el-input v-model="member.name"
                                                placeholder="请输入亲属姓名"></el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="5">
                                    <el-form-item label-width="0px"
                                                  :rules="{required: true, message: '请选择亲属关系',trigger:'blur'}"
                                                  :prop="'relatives['+index+'].relationship'">
                                      <el-select v-model="member.relationship"
                                                 placeholder="请选择亲属关系" clearable>
                                        <el-option label="父母"
                                                   value="PARENTS"></el-option>
                                        <el-option label="子女"
                                                   value="CHILDREN"></el-option>
                                        <el-option label="配偶"
                                                   value="COUPLE"></el-option>
                                        <el-option label="其他亲属"
                                                   value="RELATIVE"></el-option>
                                        <el-option label="护工"
                                                   value="WORKER"></el-option>
                                        <el-option label="其他"
                                                   value="OTHER"></el-option>
                                      </el-select>
                                    </el-form-item>
                                  </el-col>
                                </el-row>
                              </el-col>
                              <el-col :span="11" :offset="1">
                                <el-form-item label="监护人"
                                              :rules="{required: true, message: '请选择是否是监护人',trigger:'blur'}"
                                              :prop="'relatives['+index+'].isGuardian'">
                                  <el-select v-model="member.isGuardian"
                                             placeholder="请选择是否是监护人">
                                    <el-option label="是" :value="true"></el-option>
                                    <el-option label="否" :value="false"></el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row type="flex" justify="center">
                              <el-col :span="11">
                                <el-form-item label="身份证号"
                                              :rules="{required: true, message: '请输入亲属身份证号',trigger:'blur'}"
                                              :prop="'relatives['+index+'].idCard'">
                                  <el-input v-model="member.idCard"
                                            placeholder="请输入亲属身份证号"></el-input>
                                </el-form-item>
                              </el-col>
                              <el-col :span="11" :offset="1">
                                <el-form-item label="联系方式"
                                              :rules="{required: true, message: '请输入亲属电话',trigger:'blur'}"
                                              :prop="'relatives['+index+'].phone'">
                                  <el-input v-model="member.phone"
                                            placeholder="请输入亲属电话"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row type="flex" justify="center">
                              <el-col :span="23">
                                <el-form-item label="地址">
                                  <el-input v-model="member.location"
                                            placeholder="请输入地址"></el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row type="flex" justify="center">
                              <el-col :span="24" style="text-align: center">
                                <el-button type="danger" @click="removeFamilyMember(index)"
                                           icon="el-icon-close"></el-button>
                                <el-button
                                    v-if="index == agedDialog.form.relatives.length - 1"
                                    @click="addFamilyMember"
                                    type="primary" icon="el-icon-plus"></el-button>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                        <el-col v-else :span="24"
                                style="text-align: center;height: 220px;line-height: 220px">
                          <el-button @click="addFamilyMember" type="primary" icon="el-icon-plus">
                            添加亲属
                          </el-button>
                        </el-col>
                      </el-row>
                    </div>
                    <div style="margin-top: 90px">
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="称呼">
                            <el-input v-model="agedDialog.form.nickName"
                                      placeholder="请输入称呼"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="婚姻状况">
                            <el-select v-model="agedDialog.form.marriageStatus"
                                       placeholder="请选择婚姻状况"
                                       clearable>
                              <el-option label="已婚" value="MARRIED"></el-option>
                              <el-option label="未婚" value="UNMARRIED"></el-option>
                              <el-option label="丧偶" value="WIDOWED"></el-option>
                              <el-option label="离异" value="DIVORCE"></el-option>
                              <el-option label="其他" value="OTHER"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="政治面貌">
                            <el-input v-model="agedDialog.form.politicalOutlook"
                                      placeholder="请输入政治面貌"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="血型">
                            <el-input v-model="agedDialog.form.bloodType"
                                      placeholder="请输入血型"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="民族">
                            <el-input v-model="agedDialog.form.nation"
                                      placeholder="请输入民族"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="宗教信仰">
                            <el-input v-model="agedDialog.form.religious"
                                      placeholder="请输入宗教信仰"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="文化程度">
                            <el-input v-model="agedDialog.form.education"
                                      placeholder="请输入文化程度"></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="住宅人口">
                            <el-input-number v-model="agedDialog.form.population" :min="1"
                                             label="住宅人口"></el-input-number>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="休养类型">
                            <el-select v-model="agedDialog.form.holdType" placeholder="请选择休养类型"
                                       clearable>
                              <el-option label="社会代养" value="社会代养"></el-option>
                              <el-option label="政府供养" value="政府供养"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="供养标准">
                            <el-input v-model="agedDialog.form.offerStandard"
                                      placeholder="请输入供养标准"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="12">
                          <el-form-item label="供养方式">
                            <el-select v-model="agedDialog.form.offerType" placeholder="请选择供养方式"
                                       clearable>
                              <el-option label="居家" value="HOME"></el-option>
                              <el-option label="机构" value="INSTITUTION"></el-option>
                              <el-option label="其他" value="OTHER"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="12">
                          <el-form-item label="爱好">
                            <el-input v-model="agedDialog.form.hobby"
                                      placeholder="请输入爱好"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="24">
                          <el-form-item label="户籍地址">
                            <el-input v-model="agedDialog.form.permanentAddress"
                                      placeholder="请输入户籍地址"></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>

                    </div>
                  </el-form>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="agedDialog.visible = false">取 消</el-button>
        <el-button v-if="agedDialog.mode==2" type="primary"
                   @click="handleUpdate">保存信息
        </el-button>
      </div>
    </el-dialog>

    <!--健康数据弹框-->
    <el-dialog id="health-info" v-if="healthInfoVisible"
               :visible.sync="healthInfoVisible"
               custom-class="report-screen"
               width="70%" fullscreen>
      <div slot="title" class="report-screen-title">
        <h3>{{healthInfoData.agedName}}的健康体系 &nbsp;&nbsp;&nbsp;</h3>
        <div>
          <el-rate
              v-model="4.5"
              disabled
              show-score
              text-color="#ff9900"
              score-template="{value}">
          </el-rate>
        </div>
        <div class="heath-info-printer" @click="saveImage">
          <i class="fa fa-camera" aria-hidden="true"></i>
        </div>
      </div>
      <div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-card class="box-card heath-info-card">
              <el-row :gutter="20" type="flex">
                <el-col :span="15">
                  <div class="text item heath-info-item">
                    <i class="fa fa-male" aria-hidden="true"></i>&nbsp;
                    身高: {{healthInfoData.height}} cm
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-user" aria-hidden="true"></i>&nbsp;
                    体重: {{healthInfoData.weight}} KG
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-heartbeat" aria-hidden="true"></i>&nbsp;
                    心率: {{healthInfoData.heartRate}} 次/分
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-lemon-o" aria-hidden="true"></i>&nbsp;
                    血糖: {{healthInfoData.fastingBloodGlucose}} mmol/L
                    <!--                                    <i class="fa fa-level-up icon-up-red" aria-hidden="true"></i>-->
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-birthday-cake" aria-hidden="true"></i>&nbsp;
                    甘油三酯: {{healthInfoData.triglyceride}} mmol/L
                    <!--                                    <i class="fa fa-level-down icon-down-green" aria-hidden="true"></i>-->
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-hand-paper-o" aria-hidden="true"></i>&nbsp;
                    脉搏: {{healthInfoData.pulse}} 次/分
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-stethoscope" aria-hidden="true"></i>&nbsp;
                    血压: 舒张压 {{healthInfoData.lowPressure}}mmHg，收缩压 {{healthInfoData.highPressure}}mmHg
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-briefcase" aria-hidden="true"></i>&nbsp;
                    血氧比: {{healthInfoData.bloodOxygen}} %
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-flask" aria-hidden="true"></i>&nbsp;
                    胆固醇: {{healthInfoData.totalCholesterol}} mmol/L
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-thermometer-half" aria-hidden="true"></i>&nbsp;
                    体温：{{healthInfoData.temperature}} °C
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-toggle-on" aria-hidden="true"></i>&nbsp;
                    尿酸：{{healthInfoData.uricAcid}} umol/L
                  </div>
                  <div class="text item heath-info-item">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>&nbsp;
                    医生诊断：{{healthInfoData.doctorAnalysis}}
                  </div>
                </el-col>
                <el-col :span="9" style="text-align: center;">
                  <img src="static/asert/image/aged-back-yellow.png" style="width: 100%;height: 100%"/>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="12">
            <div id="health-info-radar" style="min-height: 500px"></div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!--工单操作记录弹框-->
    <el-dialog v-if="activitiesDialog.visible" :title="activitiesDialog.title"
               :visible.sync="activitiesDialog.visible"
               width="50%" :close-on-click-modal="false">
      <div :style="{'height':(indexVue.minPageHeight - 300) +'px'}">
        <el-scrollbar style="height: 100%">
          <div class="block" style="padding: 15px">
            <el-timeline>
              <template v-for="activity in activitiesDialog.data.woActivities">
                <el-timeline-item :timestamp="activity.createTime" placement="top">
                  <el-card>
                    <h4>{{enumsFormatter(null,{property:'activityType'},activity.type)}}</h4>
                    <p>{{activity.content}}</p>
                  </el-card>
                </el-timeline-item>
              </template>
            </el-timeline>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>

    <!--    床位页面  编辑页面-->
    <el-dialog v-if="bedDialogVisible" :title="bedDialogTitle" :visible.sync="bedDialogVisible" :close-on-click-modal="false">
      <el-form :model="agedInfo" ref="BedForm" :rules="bedRules" size="small">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="老人姓名" prop="agedInfo" :label-width="lableWidth">
              <el-input v-model="agedInfo.agedName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="床位设置" prop="bedName" :label-width="lableWidth">
              <el-cascader
                  v-model="value"
                  :options="roomBeds"
                  @change="handleChange"></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入住登记" prop="agedInfo" :label-width="lableWidth">
              <el-date-picker
                  v-model="agedInfo.checkInTime"
                  type="date"
                  placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bedDialogVisible = false">取 消</el-button>
        <el-button  @click="handleUpdBed">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="mapDialog.visible" :title="mapDialog.title"
               :visible.sync="mapDialog.visible" custom-class="map-dialog"
               width="50%" :close-on-click-modal="false">
      <div id="location-map" style="height: 500px"></div>
      <div id="pickerBox">
        <input id="pickerInput" placeholder="输入关键字选取地点" />
        <div id="poiInfo"></div>
      </div>
    </el-dialog>
    <!-- 设备记录-->
    <el-dialog v-if="logDialog.visible" :title="logDialog.title"
               :visible.sync="logDialog.visible"
               width="70%" :close-on-click-modal="false" top="7vh">
      <div class="dialog-page">
        <el-table :data="logDialog.table.data" stripe :height="indexVue.minPageHeight - 240">
          <el-table-column prop="roomName" label="房间"></el-table-column>
          <el-table-column prop="logDate" label="记录时间"></el-table-column>
          <el-table-column prop="status" :formatter="logStatusFormat" label="行为"></el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getGetRoomBed, getHandleAgedFileSuccess,
  getHandleFamily,
  getLoadAgedInfo,
  getLoadAgedStandards,
  getLoadAgedTypes,
  getLoadFamilies, getLoadHealthInfo, getRemoveFile1, getShowActivity,
  postHandleUpdate,
  postHandleUpdBed, postLoadAgedFiles,
  postLoadAgedLogs, postLoadCallRecordData,
  postLoadDeviceTable,
  postLoadHealthCheckTable, postLoadHealthTable,
  postLoadLogTable, postLoadWoTable
} from "@/api/aged/aged_detail";

import {getGetProvinces, getNextLevel} from "@/api/aged/aged_record";


export default {
  name: "aged_detail",
  data: function () {
    return {
      agedId:this.$route.params.agedId,
      // source:source,
      ip:'/system-ya',
      enums:{
        serviceType:{
          'SELF_BUY':'自费购买',
          'OTHER_BUY':'爱心援助',
          'GOVERNMENT_BUY':'政府购买',
        },
        woStatus:{
          'CREATE':'已创建',
          'APPROVE':'已审核',
          'PUBLISH':'已发布',
          'PROGRESS':'处理中',
          'PAUSE':'暂停中',
          'FINISH':'已完成',
          'EVALUATED':'已评价',
          'VERIFIED':'已验证',
          'ARCHIVED':'已存档',
          'CLOSED':'已终止',
        },
        activityType:{
          'CREATE':'创建',
          'APPROVE':'审核',
          'UPDATE':'编辑',
          'PUBLISH':'发布',
          'ACCEPT':'接单',
          'RETURN':'退单',
          'PAUSE':'暂停',
          'CONTINUE':'继续',
          'FINISH':'完成',
          'EVALUATE':'评价',
          'VERIFIED':'验证',
          'ARCHIVE':'存档',
          'CLOSE':'终止',
        },
        needReturn:{
          'true':'是',
          'false':'否'
        },
        woSource:{
          'PLAN':'计划生成',
          'TEMPLATE':'临时工单',
          'SEAT_WORK':'坐席派工',
          'ALARM':'告警工单',
          'DEVICE_PATROL':'设备巡查',
          'INSTALL_EQUIPMENT':'装机'
        },
        connectType:{
          'normal':'普通来电',
          'dialout':'外呼去电',
          'transfer':'来电转接',
          'dialTransfer':'外呼转接'
        },
        status:{
          'dealing':'已接听',
          'notDeal':'振铃未接听',
          'queueLeak':'排队放弃',
          'voicemail':'已留言',
          'leak':'IVR放弃',
          'blackList':'黑名单',
        }
      },
      birthPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '四十岁',
          onClick(picker) {
            const date = new Date();
            date.setFullYear(date.getFullYear() - 40);
            picker.$emit('pick', date);
          }
        }, {
          text: '六十岁',
          onClick(picker) {
            let date = new Date();
            date.setFullYear(date.getFullYear() - 60);
            picker.$emit('pick', date);
          }
        }, {
          text: '八十岁',
          onClick(picker) {
            let date = new Date();
            date.setFullYear(date.getFullYear() - 80);
            picker.$emit('pick', date);
          }
        }]
      },
      lableWidth:"80px",
      agedInfo:{
        familyId:'',
        xiaoxinhuan:'',
        depositPayment:'',
        advancePayment:'',
        replacePayment:'',
        conRoomBedId:'',
        checkInTime:'',
        id: '',
        icon: '',
        c: '',
        idCard: '',
        cardType: 'ID_CARD',
        agedName: '',
        agedSex: 1,
        birthday: '',
        birthDateType: 1,
        phone: '',
        isLocal: true,
        subsidyStandard: '',
        agedSource: 'SOCIETY',
        callbackSupport: true,
        agedType: '',
        serviceStatus: 'NORMAL',
        notices: '',
        location: '',
        relatives: [{
          id: '',
          name: '',
          phone: '',
          idCard: '',
          relationship: '',
          isGuardian: true,
          location: ''
        }],
        nickName: '',
        marriageStatus: '',
        politicalOutlook: '',
        bloodType: '',
        nation: '',
        religious: '',
        education: '',
        population: 1,
        holdType: '',
        offerStandard: '',
        offerType: '',
        hobby: '',
        permanentAddress: '',
      },
      agedTypes: [],
      agedStandards: [],
      families: [],
      qrCodeDialog:{
        visible: false
      },
      agedDialog: {
        mode: 2,
        visible: false,
        title: '信息完善',
        form: {
          id: '',
          icon: '',
          familyId: '',
          idCard: '',
          cardType: 'ID_CARD',
          agedName: '',
          agedSex: 1,
          birthday: '',
          birthDateType: 1,
          phone: '',
          isLocal: true,
          subsidyStandard: '',
          agedSource: 'SOCIETY',
          callbackSupport: true,
          agedType: '',
          serviceStatus: 'NORMAL',
          notices: '',
          location: '',
          relatives: [{
            id: '',
            name: '',
            phone: '',
            idCard: '',
            relationship: '',
            isGuardian: true,
            location: ''
          }],
          nickName: '',
          marriageStatus: '',
          politicalOutlook: '',
          bloodType: '',
          nation: '',
          religious: '',
          education: '',
          population: 1,
          holdType: '',
          offerStandard: '',
          offerType: '',
          hobby: '',
          permanentAddress: '',
          province: '',
          city: '',
          county: '',
          area: '',
          street: '',
        },
        rules: {
          idCard: [
            {required: true, message: '证件号不能为空', trigger: 'blur'}
          ],
          agedName: [
            {required: true, message: '长者姓名不能为空', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '联系电话不能为空', trigger: 'blur'}
          ],
          location: [
            {required: true, message: '地址不能为空', trigger: 'blur'}
          ]
        }
      },
      agedLogs:[],

      registrationTable: {
        condition: {
          "name": "",
          "date": []
        },
        page: {
          "currentPage": 1,
          "pageSize": 10,
          "total": 0
        },
        data: []
      },
      healthTable: {
        condition: {
          "info": ""
        },
        page: {
          "currentPage": 1,
          "pageSize": 10,
          "total": 0
        },
        data: []
      },
      healthInfoVisible: false,
      healthInfoData: {
        'id': '',
        'agedId': '',
        'checkDate': '',
        'checkLocation': '',
        'result': '',
        'registrationPerson': '',
        'registrationTime': '',
        'pictures': [],
        'attachments': [],

        'height': '',
        'weight': '',
        'temperature': '',

        'highPressure': '',
        'lowPressure': '',
        'pulse': '',
        'bloodOxygen': '',

        'fastingBloodGlucose': '',
        'postprandialBloodGlucose': '',

        'totalCholesterol': '',
        'triglyceride': '',
        'highDensity': '',
        'lowDensity': '',
        'uricAcid': '',

        'qrsInterval': '',
        'doctorAnnotation': '',
        'doctorAnalysis': '',
        'rrInterval': '',

        'heartRate': ''
      },

      woTable:{
        condition:{
          "agedName":"",
          "serviceType":"",
          "serviceOffer":"",
          "servicePerson":"",
          "planStartTime":{
            "start":'',
            "end":''
          },
          "woSource":"",
          "serviceContent":"",
          "needReturn":""
        },
        page:{
          "currentPage":1,
          "pageSize":10,
          "total":0
        },
        data:[],
        currentRow:''
      },
      activitiesDialog:{
        visible: false,
        title: '工单操作记录',
        data:{
          woActivities:[]
        }
      },

      callRecordTable:{
        condition:{
          "info":"",
          "callDate":{
            "startDate":'',
            "endDate":''
          },
          "callNum":'',
          "agedName":''
        },
        page:{
          "currentPage":1,
          "pageSize":10,
          "total":0
        },
        data:[]
      },

      files:{
        idCardFile:[],
        moveInFile:[],
        familyRegisterFile:[],
        receiptFile:[],
        reportFile:[],
        contractFile:[],
        otherFile:[],
      },
      bedDialogVisible:false,
      bedDialogTitle:'编辑',
      bedRules:{},
      roomBeds:[],
      value:[],
      mapDialog: {
        visible: false,
        title: '地图'
      },
      provinces:[],
      citys:[],
      countys:[],
      areas:[],
      streets:[],
      GatewayDialog:{
        gatewayId:'',
      },
      deviceTable: {
        condition:{
          online:'',
          gatewayId:''
        },
        page: {
          "currentPage": 1,
          "pageSize": 10,
          "total": 0
        },
        data: []
      },
      fileData:{
        id:'',
        agedId:'',
        fileId:'',
        type:'',
      },
      logDialog:{
        mode:1,
        visible: false,
        title: '',
        table: {
          condition:{
            deviceId:'',
            size:50
          },
          page: {
            "currentPage": 1,
            "pageSize": 10,
            "total": 0
          },
          data: []
        }
      }
    }
  },
  mounted: function () {
    this.loadAgedInfo();
    this.loadAgedTypes();
    this.loadAgedStandards();
    this.loadFamilies();
    this.getRoomBed();
    this.getProvinces();

  },
  methods: {

    skip() {
      // this.$router.push('/aged/aged_record');
      // this.$router.push({name:"detail" ,params:{agedId:agedId}});
      // this.$router.go(-1)
      this.$router.replace( '/aged/aged_record')

    },

    handleFamily(familyId){
      let me = this;
      getHandleFamily(familyId)
          .then(result=>{
            if(result.data){
              me.GatewayDialog.id = result.data.id;
              me.deviceTable.condition.gatewayId = result.data.id;
              me.loadDeviceTable();
            }
          })
    },
    loadDeviceTable(){
      let me = this;
      let param = {};
      param.page = {
        currentPage: me.deviceTable.page.currentPage,
        pageSize: me.deviceTable.page.pageSize
      };
      param.condition = me.deviceTable.condition;
      postLoadDeviceTable(param)
          .then(result=>{
            if (result.data) {
              me.deviceTable.data = result.data.content;
              me.deviceTable.page.currentPage = result.data.page.currentPage;
              me.deviceTable.page.total = result.data.page.total;
            }
          })
    },
    showLogDialog(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要查看的设备");
        return;
      }
      me.logDialog.table.condition.deviceId = id;
      me.logDialog.visible = true;
      me.logDialog.title = "日志查看";
      me.$nextTick(()=>{
        me.loadLogTable();
      })
    },
    loadLogTable(){
      let me = this;
      let param = {};
      if(!me.logDialog.table.condition.deviceId){
        return;
      }
      param.deviceId = me.logDialog.table.condition.deviceId;
      if(me.logDialog.table.condition.size){
        param.size = me.logDialog.table.condition.size;
      }
      postLoadLogTable(param)
          .then(result=>{
            if(result.data){
              me.logDialog.table.data = result.data;
            }
          })
    },
    logStatusFormat(row,column, cellValue) {
      if(cellValue){
        if(cellValue === 1){
          return "进入";
        } else if(cellValue === 2){
          return "离开";
        } else if(cellValue === 3){
          return "开门";
        } else if(cellValue === 4){
          return "关门";
        } else {
          return cellValue;
        }
      } else {
        return "-";
      }
    },

    //获取省
    getProvinces:function () {
      let me = this;
      getGetProvinces()
          .then(result=>{
            if(result.data){
              me.provinces = result.data;
            }
          })
    },
    getCitys:function (parentId) {
      this.agedDialog.form.city = '';
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.clearCitys();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.citys = result.data;
              }
            })
      }

    },
    getCity:function (parentId) {
      let me = this;
      me.citys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.citys = result.data;
            }
          })
    },
    getCountys:function (parentId) {
      this.agedDialog.form.county = '';
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.clearAreas();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.countys = result.data;
              }
            })
      }
    },
    getCounty:function (parentId) {
      let me = this;
      me.countys = [];
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.countys = result.data;
            }
          })
    },
    getAreas:function (parentId) {
      console.log(parentId)
      this.agedDialog.form.area = '';
      this.agedDialog.form.street = '';
      this.clearStreets();
      if (!parentId){
        return;
      }else {
        let me = this;
        getNextLevel(parentId)
            .then(result=>{
              if(result.data){
                me.areas = result.data;
              }
            })
      }
    },
    getArea:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.areas = result.data;
            }
          })
    },
    getStreets:function (parentId) {
      console.log(parentId)
      this.agedDialog.form.street = '';
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    getStreet:function (parentId) {
      let me = this;
      getNextLevel(parentId)
          .then(result=>{
            if(result.data){
              me.streets = result.data;
            }
          })
    },
    clearCitys:function () {
      let me = this;
      me.citys = [];
      me.clearCountys();
    },
    clearCountys:function () {
      let me = this;
      me.countys = [];
      me.clearAreas();
    },
    clearAreas:function () {
      let me = this;
      me.areas = [];
      me.clearStreets();
    },
    clearStreets:function () {
      let me = this;
      me.streets = [];
    },
    // 获取下拉框
    getRoomBed:function () {
      let me = this;
      getGetRoomBed()
          .then(result=>{
            if(result.data){
              me.roomBeds = result.data;
              me.loadAgedInfo();
            }
          })
    },
    //床位
    handleBedAdd:function () {
      let me = this;
      me.bedDialogTitle = "设置";
      me.bedDialogVisible = true;
    },
    handleChange(value) {
      console.log(value);
      this.value = value;
    },
    //更新bed表
    handleUpdBed(){
      console.log("aaaaaaaaaa");
      let me = this;
      let length = this.value.length;
      if(length > 0){
        this.agedInfo.conRoomBedId = this.value[length-1];
      }
      let param = this.agedInfo;
      postHandleUpdBed(param)
          .then(result=>{
            if(result.data){
              me.$message.success("保存成功");
              me.bedDialogVisible = false;
              me.loadAgedInfo();

            }
          })
    },

    loadAgedInfo(){
      if (!this.agedId) {
        return false;
      }
      let me = this;
      getLoadAgedInfo(this.agedId)
          .then(result=>{
            if (result.data) {
              me.agedInfo = result.data;
              me.agedDialog.form = result.data;
              // me.handleFamily(result.data.familyId);
              me.$nextTick(()=>{
                $("#mini-qr-code").empty();
                $("#mini-qr-code").qrcode({
                  render: "table", //table方式
                  width: 10, //宽度
                  height:10, //高度
                  text: toUtf8(JSON.stringify(me.agedInfo.id)) //任意内容
                })
              })
              let node = getTreeNode(result.data.conRoomBedId,'ConRoomBed',me.roomBeds);
              if(node && node.path){
                me.value = node.path;
              }else {
                me.value = [];
              }console.log("value....."+me.value)
              //加载日志记录
              me.loadAgedLogs(result.data.id);
              //加载体检记录
              me.loadHealthCheckTable();
              //加载健康数据
              me.loadHealthTable();
              //加载工单数据
              me.loadWoTable();
              //加载通话记录
              me.loadCallRecordData();
              //加载附件
              me.loadAgedFiles();
              if (!result.data.city){
                return;
              }else {
                //加载县
                me.getCounty(result.data.city);
              };
              if (!result.data.province){
                return;
              }else {
                //加载市
                me.getCity(result.data.province);
              };
              if (!result.data.county){
                return;
              }else {
                //加载区
                me.getArea(result.data.county);
              };
              if (!result.data.area){
                return;
              }else {
                //加载街道
                me.getStreet(result.data.area);
              };
            }
          })
    },
    loadAgedTypes() {
      let me = this;
      getLoadAgedTypes()
          .then(result=>{
            if (result.data) {
              me.agedTypes = result.data;
            }
          })
    },
    loadAgedStandards() {
      let me = this;
      getLoadAgedStandards()
          .then(result=>{
            if (result.data) {
              me.agedStandards = result.data;
            }
          })
    },
    loadFamilies() {
      let me = this;
      getLoadFamilies()
          .then(result=>{
            if (result.data) {
              me.families = result.data;
            }
          })
    },
    loadAgedLogs(id){
      if(!id){
        return;
      }
      let me = this;
      postLoadAgedLogs(id)
          .then(result=>{
            if (result.data) {
              me.agedLogs = result.data;
            }
          })
    },
    showQRCode(data){
      this.qrCodeDialog.visible = true;
      this.$nextTick(()=>{
        $("#aged-qr-code").empty();
        $("#aged-qr-code").qrcode({
          render: "table", //table方式
          width: 400, //宽度
          height:400, //高度
          text: toUtf8(JSON.stringify(data)) //任意内容
        })
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.id) {
        this.agedDialog.form.icon = res.id;
      }
    },
    addFamilyMember() {
      this.agedDialog.form.relatives.push({
        id: '',
        name: '',
        phone: '',
        idCard: '',
        relationship: '',
        isGuardian: true,
        location: ''
      });
    },
    removeFamilyMember(index) {
      if (index || index === 0) {
        this.agedDialog.form.relatives.splice(index, 1);
      }
    },
    openAgedDialog(){
      this.agedDialog.visible = true;
    },
    handleUpdate() {
      let me = this;
      this.$refs['aged-form'].validate((valid) => {
        if (valid) {
          let param = this.agedDialog.form;
          postHandleUpdate(param)
              .then(result=>{
                me.$message.success("保存成功");
                me.loadAgedInfo();
                me.agedDialog.visible = false;
              })
        }
      });
    },
    handleDelAged() {
      let me = this;
      if (!me.agedId) {
        return;
      }
      this.$confirm('是否删除此长者相关信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        $.ajax({
          url: "aged/remove/" + me.agedId,
          type: 'GET',
          success: function (result) {
            me.$message.success("删除成功");
            indexVue.handleSelect(me.source);
          }
        });
      });
    },
    toCard(){
      let me = this;
      if (!me.agedId) {
        return;
      }
      this.$confirm('是否前往制卡页面?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        indexVue.handleSelect('800_400_101?agedId='+me.agedId)
      }).catch(()=>{});
    },

    loadHealthCheckTable(){
      let me = this;
      if (!me.agedId) {
        return;
      }
      let param = {};
      param.page = {
        currentPage:me.registrationTable.page.currentPage,
        pageSize:me.registrationTable.page.pageSize
      };
      param.condition = {
        agedId : me.agedId
      };
      postLoadHealthCheckTable(param)
          .then(result=>{
            if(result.data){
              me.registrationTable.data = result.data.content;
              me.registrationTable.page.currentPage = result.data.page.currentPage;
              me.registrationTable.page.total = result.data.page.total;
            }
          })
    },
    loadHealthTable() {
      let me = this;
      if (!me.agedId) {
        return;
      }
      let param = {};
      param.page = {
        currentPage: me.healthTable.page.currentPage,
        pageSize: me.healthTable.page.pageSize
      };
      param.condition = me.healthTable.condition;
      param.condition.agedId = me.agedId;
      postLoadHealthTable(param)
          .then(result=>{
            if (result.data) {
              me.healthTable.data = result.data.content;
              me.healthTable.page.currentPage = result.data.page.currentPage;
              me.healthTable.page.total = result.data.page.total;
            }
          })
    },
    loadHealthInfo(id) {
      if(!id){
        return;
      }
      let me = this;
      getLoadHealthInfo(id)
          .then(result=>{
            if (result.data) {
              me.healthInfoData = result.data;
              me.getHeathInfo();
            }
          })
    },
    getHeathInfo() {
      this.healthInfoVisible = true;

      let healthInfo = [];
      healthInfo.push(this.healthInfoData.heartRate);
      healthInfo.push(this.healthInfoData.highPressure);
      healthInfo.push(this.healthInfoData.lowPressure);
      healthInfo.push(this.healthInfoData.triglyceride);
      healthInfo.push(this.healthInfoData.totalCholesterol);
      healthInfo.push(this.healthInfoData.fastingBloodGlucose);
      healthInfo.push(this.healthInfoData.bloodOxygen);
      healthInfo.push(this.healthInfoData.uricAcid);
      healthInfo.push(this.healthInfoData.temperature);

      this.$nextTick(() => {
        let c = eChartTool.getRadarChart("health-info-radar", {
          legendData: ['最低警戒值', '最高警戒值', '我的数据'],
          indicator: [{
            text: '心率(次/分)',
            max: 150,
          }, {
            text: '收缩压(mmHg)',
            max: 200
          }, {
            text: '舒张压(mmHg)',
            max: 150
          }, {
            text: '甘油三酯(mmol/L)',
            max: 6,
          }, {
            text: '总胆固醇(mmol/L)',
            max: 25
          }, {
            text: '血糖(mmol/L)',
            max: 15
          }, {
            text: '血氧(%)',
            max: 100
          }, {
            text: '尿酸',
            max: 600
          }, {
            text: '体温(°C)',
            max: 40
          }],
          colorArr: ['#34da62', '#eb3600', '#00c0e9'],
          series: [[60, 90, 60, 0, 3.1, 3.9, 10, 50, 36], [100, 130, 80, 1.7, 5.2, 6.1, 30, 500, 38], healthInfo],
          axisLineColor: '#153269',
          splitLineColor: '#113865'
        });
      });
    },
    saveImage() {
      canvasTool.saveImage("health-info", this.healthInfoData.agedName+"的健康数据");
    },

    loadWoTable(){
      let me = this;
      if (!me.agedId) {
        return;
      }
      let param = {};
      param.page = {
        currentPage:me.woTable.page.currentPage,
        pageSize:me.woTable.page.pageSize
      };
      param.condition = me.woTable.condition;
      param.condition.agedId = me.agedId;
      postLoadWoTable(param)
          .then(result=>{
            if(result.data){
              me.woTable.data = result.data.content;
              me.woTable.page.currentPage = result.data.page.currentPage;
              me.woTable.page.total = result.data.page.total;
            }
          })
    },
    showActivity(id){
      let me = this;
      if(!id){
        this.$message.warning("请选择要查看的工单");
        return;
      }
      getShowActivity(id)
          .then(result=>{
            if(result.data){
              me.activitiesDialog.data.woActivities = result.data;
              me.activitiesDialog.visible = true;
            }
          })
    },

    loadCallRecordData() {
      let me = this;
      if (!me.agedId) {
        return;
      }
      let param = {};
      param.page = {
        currentPage:me.callRecordTable.page.currentPage,
        pageSize:me.callRecordTable.page.pageSize
      };
      param.condition = me.callRecordTable.condition;
      param.condition.agedId = me.agedId;
      postLoadCallRecordData(param)
          .then(result=>{
            if(result.data){
              me.callRecordTable.data = result.data.content;
              me.callRecordTable.page.currentPage = result.data.page.currentPage;
              me.callRecordTable.page.total = result.data.page.total;
            }
          })
    },

    idCardUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'IdCard');
    },
    moveInUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'MoveIn');
    },
    familyRegisterUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'FamilyRegister');
    },
    receiptUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'Receipt');
    },
    reportUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'Report');
    },
    contractUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'Contract');
    },
    otherUpload(res, file) {
      let me = this;
      if (!me.agedId || !res.id) {
        return;
      }
      this.handleAgedFileSuccess(me.agedId,res.id,'Other');
    },
    handleAgedFileSuccess(agedId, fileId, type) {
      let me = this;
      if (!agedId || !fileId) {
        return;
      }
      console.log("aaaa"+agedId)
      me.fileData.agedId = agedId;
      me.fileData.fileId = fileId;
      me.fileData.type = type;
      let param = me.fileData;
      getHandleAgedFileSuccess(param)
          .then(result=>{
            if(result.data){
              me.$message.success("上传成功");
              me.loadAgedFiles();
            }else {
              me.$message.error("上传失败");
            }
          })
    },
    removeFile(fileId){
      let me = this;
      if (!fileId) {
        return;
      }
      this.$confirm('是否移除此附件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        me.fileData.fileId = fileId;
        let param = me.fileData;
        getRemoveFile1(param)
            .then(result=>{
              if(result.data){
                me.$message.success("移除成功");
                me.loadAgedFiles();
              }else {
                me.$message.error("移除失败");
              }
            });
      }).catch(()=>{});
    },
    loadAgedFiles(){
      let me = this;
      if (!me.agedId) {
        return;
      }
      postLoadAgedFiles(me.agedId)
          .then(result=>{
            if(result.data){
              me.files = result.data;
            }
          })
    },
    allFile(files){
      return files.map((file)=>{
        return file.filePath
      });
    },
    enumsFormatter(row, column, cellValue){
      if(this.enums && this.enums[column.property]){
        return this.enums[column.property][cellValue];
      }else {
        return cellValue;
      }
    },
    openMapDialog(){
      this.mapDialog.title = "地图";
      this.mapDialog.visible = true;
      this.$nextTick(()=>{
        this.initMap();
      })
    },
    initMap(){
      //获取中心点
      let map = new AMap.Map('location-map', {
        resizeEnable: true,
        zoom: 13
      });
      let me = this;
      AMapUI.loadUI(['misc/PoiPicker'], function(PoiPicker) {

        let poiPicker = new PoiPicker({
          input: 'pickerInput'
        });

        //初始化poiPicker
        poiPickerReady(poiPicker);
      });

      function poiPickerReady(poiPicker) {

        // window.poiPicker = poiPicker;

        let marker = new AMap.Marker();

        let infoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -20)
        });

        //选取了某个POI
        // poiPicker.on('poiPicked', function(poiResult) {
        //
        //   let source = poiResult.source,
        //       poi = poiResult.item,
        //       info = {
        //         source: source,
        //         id: poi.id,
        //         name: poi.name,
        //         location: poi.location.toString(),
        //         address: poi.address
        //       };
        //
        //   marker.setMap(map);
        //   infoWindow.setMap(map);
        //
        //   marker.setPosition(poi.location);
        //   infoWindow.setPosition(poi.location);
        //   infoWindow.setContent('位置信息: <pre>名称: ' + poi.name +
        //       '</pre><pre>位置: ' + poi.address +
        //       '</pre><pre style="text-align: right">' +
        //       '<a href="javascript:void(0);" ' +
        //       'onclick="markerSelect(\''+poi.name+'\',\''+poi.address+'\','+poi.location.lng+','+poi.location.lat+')">确定</a></pre>');
        //   infoWindow.open(map, marker.getPosition());
        //
        //   map.setCenter(marker.getPosition());
        //
        //   function markerClick() {
        //     infoWindow.setContent('位置信息: <pre>名称: ' + poi.name + '</pre><pre>位置: ' + poi.address + '</pre>');
        //     infoWindow.open(map, marker.getPosition());
        //   }
        //
        //   marker.on('click', markerClick);
        //
        // });
        //
        // if(me.agedDialog.form.lng && me.agedDialog.form.lat){
        //   let name = me.agedDialog.form.location;
        //   let address = me.agedDialog.form.address;
        //   let lng = me.agedDialog.form.lng;
        //   let lat = me.agedDialog.form.lat;
        //   let position = new AMap.LngLat(lng, lat);
        //
        //   marker.setMap(map);
        //   infoWindow.setMap(map);
        //
        //   marker.setPosition(position);
        //   infoWindow.setPosition(position);
        //   infoWindow.setContent('位置信息: <pre>名称: ' + name +
        //       '</pre><pre>位置: ' + address +
        //       '</pre><pre style="text-align: right">' +
        //       '<a href="javascript:void(0);" onclick="markerSelect(\''+name+'\',\''+position+'\')">确定</a></pre>');
        //   infoWindow.open(map, marker.getPosition());
        //
        //   map.setCenter(marker.getPosition());
        // }
      }
    }
  }
}
</script>

<style scoped>
.account-title {
  color: #909399;
  font-size: 14px;
  margin-bottom: 15px;
}
.account-label {
  text-align: center;
  color: #C0C4CC;
  font-size: 12px;
}
.account-number {
  text-align: center;
  color: #606266;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.tab-pane{
  padding: 40px 0px;
}
.heath-info-card {
  margin-left: 50px;
  padding: 30px;
  background-color: rgba(64, 158, 255, 0.3);
}

.heath-info-item {
  height: 40px;
  line-height: 40px;
  color: #FFFFFF;
}

.heath-info-printer {
  position: fixed;
  top: 50px;
  right: 40px;
  font-size: 1.5em;
  cursor: pointer;
}
.card-title {
  color: #909399;
  font-size: 14px;
  border-left: 2px solid #1b78e6;
}
.page-title {
  background-color: #E4E7ED;
  padding: 10px 5px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: visible;
}
.img-line {
  position: relative;
  display: inline-block;
}
.img-line-button {
  position: absolute;
  bottom: 11px;
  height: 30px;
  line-height: 30px;
  left: 0;
  width: 100%;
  background-color: rgba(252, 109, 68, 0.5);
  color: #ffffff;
  text-align: center;
}
.img-line .img-line-button {
  display: none;
}
.img-line:hover .img-line-button {
  display: block;
  cursor: pointer;
}
.amap_lib_placeSearch .poibox.highlight {
  background-color: #CAE1FF;
}

.amap_lib_placeSearch .poi-more {
  display: none!important;
}

.map-dialog > .el-dialog__body{
  padding: 0;
}
#pickerBox {
  position: absolute;
  z-index: 9999;
  top: 60px;
  left: 30px;
  width: 300px;
}
#pickerInput {
  width: 200px;
  padding: 5px 5px;
}

#poiInfo {
  background: #fff;
}
</style>